export const blogPosts = [
  {
    id: 1,
    title: 'Understanding Compound Interest',
    summary: 'A deep dive into how compound interest can work for you.',
    content: "This is the full content of the blog post about compound interest. Compound interest is the eighth wonder of the world. He who understands it, earns it ... he who doesn't ... pays it.",
    category: 'Investing',
  },
  {
    id: 2,
    title: 'Tips for Managing Your Personal Finances',
    summary: 'Practical advice for taking control of your financial future.',
    content: 'This is the full content of the blog post about personal finance tips. A personal budget is the first step to financial freedom. It is the compass that guides your financial ship.',
    category: 'Personal Finance',
  },
];